import { BaseHttpClient } from '@/modules/common/services/http/__deprecated__/base-http-client';
import { IFeed } from './types';

export class NewsAPI extends BaseHttpClient {
  constructor() {
    super(undefined, process.env.VUE_APP_BFF_URL);
  }

  public async getHomeNews(): Promise<IFeed> {
    return this.get(`/notification/v1/news/feed`);
  }

  public async trackNewsRead(code: string) {
    return this.put(`/notification/v1/news/read/${code}`);
  }

  public async trackNewsDiscard(code: string) {
    return this.put(`/notification/v1/news/discard/${code}`);
  }
}
